<template>

  <div :class="'modal' + (modal ? ' is-active' : '')">
    <div class="modal-background"></div>
    <div class="modal-card is-small checkbox-dark">
      <header class="modal-card-head">
        <!-- <button class="delete" aria-label="close" @click="modal = false"></button> -->
        <p class="modal-card-title has-text-black">Welcome</p>
      </header>

      <section class="modal-card-body ph20">
        <p class="has-text-centered mb20 is-size-14">What should we call you ?</p>
        <form data-vv-scope="loginform" @submit.prevent="loginAsGuest()" ref="form" >
          <div class="signup-modal-fields">
            <div class="field">
              <div class="control">
                <input
                  class="input"
                  name="email"
                  v-model="form.first_name"
                  type="text"
                  placeholder="Input Name"
                />
              </div>
            </div>
          </div>
        </form>

      </section>

      <footer class="modal-card-foot">
        <div class="column p0">
        <button
          @click="loginAsGuest()"
          class="button is-large bg-secondary text-white hover-opacity-7 is-full-width"
        >SHOP AS GUEST</button>

        <p class="text-center is-size-14 mt40 has-text-black mb10">
          Start enjoying member benefits! 
        </p>

        <div class="has-text-centered">
          <a href="#" class="text-secondary hover-text-secondary is-size-14 hover-opacity-8 has-text-weight-semibold" @click.prevent="signUpScreen()">JOIN NOW</a>
          <span class="has-text-weight-semibold mr10 ml10">or</span>
          <a href="#" class="text-secondary hover-text-secondary is-size-14 hover-opacity-8 has-text-weight-semibold" @click.prevent="signInScreen()">SIGN IN</a>
        </div>
        <p class="text-center is-size-11 mt30 text-primary">POWERED BY <img class="powered-logo" alt="logo" src="@/assets/img/logo.png" /></p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";
import LoginApis from '@/Components/Controllers/LoginApis';
import CartApis from '@/Components/Controllers/CartApis';
import UserApis from '@/Components/Controllers/UserApis';

export default {
  name: "inStoreModal",

  data() {
    return {
      modal: false,
      form: {
        first_name: '',
      },
    };
  },

  computed: {
  
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
      vg_redirect: "loginmodal/redirect",
      vg_selectedStore: "location/selected", 
      vg_cartId: "cart/id",
      vg_cartItems: "cart/cartItems",
      vg_pendingItemOnCart: "cart/pendingItem",
      vg_userId: "getLoggedInUserId",
      vg_businessLoyality: "businessprofile/businessLoyality",
    })
  },

  async mounted() {
    bus.$on('in-store-modal', (payload) => {
      this.modal = payload;
    })
  },

  beforeDestroy() {
    bus.$off('in-store-modal');
  },

  methods: {

    /**
     * Anynomous user
     */
    async loginAsGuest() {
      this.va_spinner(true);
      const self = this;
      let res = await LoginApis.addAnonymous({ 
          registered_from: 'budtender', // hardcoded for now
          location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id : null,
          first_name: this.form.first_name,
          business_id: this.vg_businessProfile.id ? this.vg_businessProfile.id : null,
      });
      if(res.status != 201){
        this.va_spinner(false);
        this.va_snackbar({
          type: 'warning',
          message: res.response.data.msg,
        });
      } else {
        //await this.$store.dispatch("REMOVE_APP_DATA");
        await this.$store.dispatch("SET_USER_TOKEN", res.data.payload.token);
        await this.$store.dispatch("SET_USER_DETAILS", res.data.payload);
        this.va_snackbar({
          type: 'success',
          message: 'Successfully logged in...',
        });

        UserApis.addUserLocation(this.$store.getters.getLoggedInUserId, this.vg_selectedStore.id, this.$route.query);

        if(!_.isEmpty(this.vg_selectedStore) && this.vg_selectedStore.id != ''){
          await CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        }
        this.va_spinner(false);
        this.modal = false;

        // for Anynomous user already subscribed to business loyalty from api side so check only instore
        if( this.vg_businessLoyality.id && this.vg_businessLoyality.is_active && this.vg_userId && ( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true') )){
          let userCheckInres = await UserApis.userLoyalityCheckIn(this.vg_businessProfile.id, this.vg_selectedStore.id, this.vg_selectedStore.name); 
          if(userCheckInres.status == 200){
            // alert modal
            bus.$emit('loyality-checkin-congratulations', {
              modal: true,
              point: userCheckInres.data.payload.points_earned,
              message: "You've checked in!",
            })
            this.va_setUserLoyalityObj({
              user_id: this.vg_userId, 
              business_id: this.vg_businessProfile.id,
            });
          }
        }

      }
    },

    /**
     * Show signup modal
     */
    signUpScreen() {
      this.modal = false;
      this.va_setSignupModal(true);
    },

    /**
     * Show login modal
     */
    signInScreen() {
      this.modal = false;
      this.va_setLoginModal(true);
    },

    ...mapActions({
      va_setLoginModal: "loginmodal/setModal",
      va_setSignupModal: "signupmodal/setModal",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_joinUserOnLoyalityProgram: "userloyalitysubscription/joinUserOnLoyalityProgram",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })
  }
};
</script>